// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../srprsme-react-website/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../srprsme-react-website/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
	FILE: _core.scss

	USED ON:
		- srprs.me/*

	USAGE:
		Meant for 'sitewide' stylesheets aka stylesheets that are needed on every page. Please be careful with this one, don't add unnecessary partials when they're not needed on every page since this slows down the loading/rendering time!!!1!1

	NOTES:
		NEVER use @import "base/*"; or such, read this => http://stackoverflow.com/a/4779432
*/
.clearfix {
  overflow: auto;
}

.display-flex {
  display: inline;
}
@media only screen and (min-width: 767px) {
  .display-flex {
    display: flex;
  }
}

.full-width {
  width: 100%;
}

@media only screen and (max-width: 767px) {
  .mobile-full-width {
    width: 100%;
  }
}

@media only screen and (min-width: 767px) {
  .width-49 {
    width: 49%;
  }
}

.pull-left {
  float: left;
}

.pull-right {
  float: right;
}

.margin-b-s {
  margin-bottom: 10px;
}

.margin-b-m {
  margin-bottom: 20px;
}

.margin-b-l {
  margin-bottom: 40px;
}

.padding-t-s {
  padding-top: 10px;
}

.padding-t-s-7 {
  padding-top: 7px;
}

.padding-l-s {
  padding-left: 10px;
}

.padding-r-s {
  padding-right: 10px;
}

.padding-r-m {
  padding-right: 20px;
}

.padding-r-xl {
  padding-right: 60px;
}

.text-centered {
  text-align: center;
}

.text-bold {
  font-weight: bold;
}

.text-small {
  font-size: 14px;
}

.text-medium {
  font-size: 20px;
}

.text-large {
  font-size: 24px;
}

.text-xlarge {
  font-size: 28px;
}

.text-uppercase {
  text-transform: uppercase;
}

.is-loading,
.loading {
  color: #ececec;
  background-color: #ececec;
}
.is-loading::selection, .is-loading::-moz-selection,
.loading::selection,
.loading::-moz-selection {
  background: #ececec;
}

@media screen and (max-width: ) {
  body:before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 375px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 640px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 768px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1024px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1280px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1440px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1600px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
/*
	usage:

	.element {
		@include browserfix(ie) {
			&:after {
				content: "This is IE only"
			}
		}
		@include browserfix(firefox) {
			&:after {
				content: "Only Firefox users will see this";
			}
		}
	}
*/
@keyframes buttonDisabled {
  10%, 90% {
    transform: translate3d(-1px, 0, 0);
  }
  20%, 80% {
    transform: translate3d(2px, 0, 0);
  }
  30%, 50%, 70% {
    transform: translate3d(-4px, 0, 0);
  }
  40%, 60% {
    transform: translate3d(4px, 0, 0);
  }
}
.srprs-breadcrumbs {
  display: flex;
  position: relative;
  overflow-x: hidden;
  margin-bottom: 15px;
}
.srprs-breadcrumbs + h1.srprs-heading {
  font-size: 22px;
}
.srprs-breadcrumbs li {
  display: flex;
  align-items: center;
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;
}
.srprs-breadcrumbs li > a,
.srprs-breadcrumbs li > span:first-child {
  color: inherit;
  font: inherit;
  padding-top: 3px;
  padding-right: 3px;
  padding-bottom: 3px;
  padding-left: 3px;
}
.srprs-breadcrumbs li > a:hover {
  text-decoration: underline;
}
.srprs-breadcrumbs li .srprs-label-box {
  border-radius: 20px;
  display: inline-block;
  color: #fff;
  padding: 4px 12px;
  margin: 0;
  opacity: 0.3;
}
.srprs-breadcrumbs li .srprs-label-box a {
  color: currentColor;
}
.srprs-breadcrumbs li .srprs-separator-line {
  display: flex;
  justify-content: center;
  align-items: center;
}
.srprs-breadcrumbs li .srprs-separator-line .srprs-icon {
  width: 10px;
  height: 10px;
}
.srprs-breadcrumbs li .srprs-separator-line .srprs-icon svg * {
  fill: white;
}
.srprs-breadcrumbs li:last-child .srprs-icon {
  display: none;
}
.srprs-breadcrumbs .is-done .srprs-label-box,
.srprs-breadcrumbs .is-active .srprs-label-box {
  opacity: 1;
}
.srprs-breadcrumbs .is-done .srprs-label-box a,
.srprs-breadcrumbs .is-active .srprs-label-box a {
  font-weight: bold;
}
.srprs-breadcrumbs .is-done {
  font-weight: 500;
}
.srprs-breadcrumbs .is-done .srprs-label-box {
  color: #fff;
}
.srprs-breadcrumbs .is-done .srprs-label-box svg {
  margin-top: 2px;
  margin-right: 4px;
}
.srprs-breadcrumbs .is-done .srprs-label-box .srprs-icon {
  display: none;
}
.srprs-breadcrumbs .is-active {
  font-weight: bolder;
}

@media screen and (min-width: 375px) {
  .srprs-breadcrumbs li {
    font-size: 13px;
  }
  .srprs-breadcrumbs li > a,
  .srprs-breadcrumbs li > span:first-child {
    padding-top: 5px;
    padding-right: 5px;
    padding-bottom: 5px;
    padding-left: 5px;
  }
  .srprs-breadcrumbs li .srprs-icon {
    width: 16px;
    transform: translateY(-2px);
  }
}
@media screen and (min-width: 640px) {
  .srprs-breadcrumbs + h2.srprs-heading {
    font-size: 30px;
  }
  .is-done .srprs-label-box .srprs-icon {
    display: inline-block !important;
  }
  .srprs-breadcrumbs li {
    font-size: 15px;
  }
  .srprs-breadcrumbs li > a,
  .srprs-breadcrumbs li > span:first-child {
    padding-top: 5px;
    padding-right: 5px;
    padding-bottom: 5px;
    padding-left: 5px;
  }
  .srprs-breadcrumbs li .srprs-icon {
    width: 20px;
    transform: translateY(-2px);
  }
}
@media screen and (min-width: 768px) {
  .srprs-breadcrumbs {
    z-index: 997;
    margin-bottom: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./../srprsme-react-components/src/components/_Assets/scss/_core.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/_helpers.scss","webpack://./../srprsme-react-components/src/components/Breadcrumbs/Breadcrumbs.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/mixins/_breakpoint.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/mixins/_browser-fixes.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/animations/_Button.scss"],"names":[],"mappings":"AAEA;;;;;;;;;;;CAAA;ACAA;EACE,cAAA;ACWF;;ADRA;EACE,eAAA;ACWF;ADVE;EAFF;IAGI,aAAA;ECaF;AACF;;ADVA;EACE,WAAA;ACaF;;ADTE;EADF;IAEI,WAAA;ECaF;AACF;;ADTE;EADF;IAEI,UAAA;ECaF;AACF;;ADVA;EACE,WAAA;ACaF;;ADVA;EACE,YAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,iBAAA;ACaF;;ADVA;EACE,gBAAA;ACaF;;ADVA;EACE,kBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,kBAAA;ACaF;;ADVA;EACE,iBAAA;ACaF;;ADXA;EACE,eAAA;ACcF;;ADZA;EACE,eAAA;ACeF;;ADbA;EACE,eAAA;ACgBF;;ADdA;EACE,eAAA;ACiBF;;ADfA;EACE,yBAAA;ACkBF;;ADfA;;EAEE,cAAA;EACA,yBAAA;ACkBF;ADjBE;;;EAEE,mBAAA;ACoBJ;;ACpFA;EAEI;IACE,iBAAA;IACA,aAAA;EDsFJ;AACF;ACvHI;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDoEN;AACF;AC7HI;EAwCE;IAcI,iBAAA;IAEF,aAAA;ED0EN;AACF;ACnII;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDgFN;AACF;ACzII;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDsFN;AACF;AC/II;EAwCE;IAcI,iBAAA;IAEF,aAAA;ED4FN;AACF;ACrJI;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDkGN;AACF;AC3JI;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDwGN;AACF;AEzIA;;;;;;;;;;;;;;;CAAA;AChCA;EACE;IAEE,kCAAA;EH0LF;EGxLA;IAEE,iCAAA;EHyLF;EGvLA;IAGE,kCAAA;EHuLF;EGrLA;IAEE,iCAAA;EHsLF;AACF;AAnMA;EACE,aAAA;EACA,kBAAA;EACA,kBAAA;EAEA,mBAAA;AAoMF;AAnME;EACE,eAAA;AAqMJ;AAlME;EACE,aAAA;EACA,mBAAA;EAEE,eAAA;EACA,gBAAA;EAGA,yBAAA;AAiMN;AA/LI;;EAEE,cAAA;EACA,aAAA;EAEE,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;AAgMR;AA7LI;EAEI,0BAAA;AA8LR;AA3LI;EACE,mBAAA;EACA,qBAAA;EACA,WAAA;EACA,iBAAA;EACA,SAAA;EACA,YAAA;AA6LN;AA5LM;EACE,mBAAA;AA8LR;AA3LI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AA6LN;AA5LM;EACE,WAAA;EACA,YAAA;AA8LR;AA5LU;EACE,WAAA;AA8LZ;AAxLM;EACE,aAAA;AA0LR;AApLI;;EAIE,UAAA;AAoLN;AAvLM;;EACE,iBAAA;AA0LR;AArLE;EAgBI,gBAAA;AAwKN;AAvLI;EAGE,WAAA;AAuLN;AAtLM;EACE,eAAA;EACA,iBAAA;AAwLR;AArLM;EACE,aAAA;AAuLR;AA/KE;EAEI,mBAAA;AAgLN;;ACjRI;EDmHA;IAEI,eAAA;EAiKN;EA/JI;;IAGI,gBAAA;IACA,kBAAA;IACA,mBAAA;IACA,iBAAA;EAgKR;EA7JI;IACE,WAAA;IACA,2BAAA;EA+JN;AACF;AClSI;ED0IA;IACE,eAAA;EA2JJ;EAtJI;IACE,gCAAA;EAwJN;EAlJE;IAEI,eAAA;EAmJN;EAjJI;;IAGI,gBAAA;IACA,kBAAA;IACA,mBAAA;IACA,iBAAA;EAkJR;EA/II;IACE,WAAA;IACA,2BAAA;EAiJN;AACF;ACxTI;ED6KF;IACE,YAAA;IAEE,mBAAA;EA6IJ;AACF","sourcesContent":["@charset \"UTF-8\";\n\n/*\n\tFILE: _core.scss\n\n\tUSED ON:\n\t\t- srprs.me/*\n\n\tUSAGE:\n\t\tMeant for 'sitewide' stylesheets aka stylesheets that are needed on every page. Please be careful with this one, don't add unnecessary partials when they're not needed on every page since this slows down the loading/rendering time!!!1!1\n\n\tNOTES:\n\t\tNEVER use @import \"base/*\"; or such, read this => http://stackoverflow.com/a/4779432\n*/\n\n// vars & helpers\n@import 'helpers/variables';\n@import 'helpers/helpers';\n\n// functions\n@import 'helpers/functions/map-deep-get';\n@import 'helpers/functions/color';\n@import 'helpers/functions/font';\n//@import \"helpers/functions/padding\";\n@import 'helpers/functions/section';\n@import 'helpers/functions/str-replace';\n@import 'helpers/functions/z-index';\n\n// mixins\n@import 'helpers/mixins/arrow';\n@import 'helpers/mixins/aspect-ratio';\n@import 'helpers/mixins/breakpoint';\n@import 'helpers/mixins/browser-fixes';\n@import 'helpers/mixins/color-schemes';\n@import 'helpers/mixins/grid';\n@import 'helpers/mixins/no-bullets';\n@import 'helpers/mixins/clearfix';\n@import 'helpers/mixins/font-face';\n@import 'helpers/mixins/scrollbars';\n@import 'helpers/mixins/transform-center';\n@import 'helpers/mixins/transition';\n@import 'helpers/mixins/truncate';\n\n// repeatables (aka think DRY and store it in an @mixin)\n@import 'helpers/repeatables/box-shadow';\n@import 'helpers/repeatables/iphonex';\n@import 'helpers/repeatables/wrapper-inner';\n\n// animations\n@import 'animations/Button';\n","@charset \"UTF-8\";\n\n.clearfix {\n  overflow: auto;\n}\n\n.display-flex {\n  display: inline;\n  @media only screen and (min-width: 767px) {\n    display: flex;\n  }\n}\n\n.full-width {\n  width: 100%;\n}\n\n.mobile-full-width {\n  @media only screen and (max-width: 767px) {\n    width: 100%;\n  }\n}\n\n.width-49 {\n  @media only screen and (min-width: 767px) {\n    width: 49%;\n  }\n}\n\n.pull-left {\n  float: left;\n}\n\n.pull-right {\n  float: right;\n}\n\n.margin-b-s {\n  margin-bottom: 10px;\n}\n\n.margin-b-m {\n  margin-bottom: 20px;\n}\n\n.margin-b-l {\n  margin-bottom: 40px;\n}\n\n.padding-t-s {\n  padding-top: 10px;\n}\n\n.padding-t-s-7 {\n  padding-top: 7px;\n}\n\n.padding-l-s {\n  padding-left: 10px;\n}\n\n.padding-r-s {\n  padding-right: 10px;\n}\n\n.padding-r-m {\n  padding-right: 20px;\n}\n\n.padding-r-xl {\n  padding-right: 60px;\n}\n\n.text-centered {\n  text-align: center;\n}\n\n.text-bold {\n  font-weight: bold;\n}\n.text-small {\n  font-size: 14px;\n}\n.text-medium {\n  font-size: 20px;\n}\n.text-large {\n  font-size: 24px;\n}\n.text-xlarge {\n  font-size: 28px;\n}\n.text-uppercase {\n  text-transform: uppercase;\n}\n\n.is-loading,\n.loading {\n  color: #ececec;\n  background-color: #ececec;\n  &::selection,\n  &::-moz-selection {\n    background: #ececec;\n  }\n}\n","$cdn-url: 'https://store.cdn.srprs.me/';\n@charset \"UTF-8\";\n\n@import '../_Assets/scss/core';\n@include color-schemes;\n\n.srprs-breadcrumbs {\n  display: flex;\n  position: relative;\n  overflow-x: hidden;\n  // background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='30' width='30'%3E%3Cline x1='0' y1='50%25' x2='100%25' y2='50%25' style='stroke:%23E9FAFA;stroke-width:2' /%3E%3C/svg%3E\");\n  margin-bottom: 15px;\n  + h1.srprs-heading {\n    font-size: 22px;\n  }\n\n  li {\n    display: flex;\n    align-items: center;\n    font: {\n      size: 12px;\n      weight: 500;\n    }\n    text: {\n      transform: uppercase;\n    }\n    > a,\n    > span:first-child {\n      color: inherit;\n      font: inherit;\n      padding: {\n        top: 3px;\n        right: 3px;\n        bottom: 3px;\n        left: 3px;\n      }\n    }\n    > a:hover {\n      text: {\n        decoration: underline;\n      }\n    }\n    .srprs-label-box {\n      border-radius: 20px;\n      display: inline-block;\n      color: color(white);\n      padding: 4px 12px;\n      margin: 0;\n      opacity: 0.3;\n      a {\n        color: currentColor;\n      }\n    }\n    .srprs-separator-line {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      .srprs-icon {\n        width: 10px;\n        height: 10px;\n        svg {\n          * {\n            fill: white;\n          }\n        }\n      }\n    }\n    &:last-child {\n      .srprs-icon {\n        display: none;\n      }\n    }\n  }\n  .is-done,\n  .is-active {\n    .srprs-label-box {\n      a {\n        font-weight: bold;\n      }\n      opacity: 1;\n    }\n  }\n  .is-done {\n    .srprs-label-box {\n      // background-color: var(--colorForegroundAccent);\n      // color: var(--colorBackground);\n      color: color(white);\n      svg {\n        margin-top: 2px;\n        margin-right: 4px;\n      }\n\n      .srprs-icon {\n        display: none;\n      }\n    }\n\n    font: {\n      weight: 500;\n    }\n  }\n  .is-active {\n    font: {\n      weight: bolder;\n    }\n  }\n\n  // @each $color, $colorBackground, $colorBackgroundAccent, $colorBackgroundTone,\n  //   $colorForeground, $colorForegroundAccent,\n  //   $colorForegroundNegative in $list-colorschemes\n  // {\n  //   .layout-#{\"\" + $color} & {\n  //     li .srprs-separator-line {\n  //       border-color: rgba($colorForegroundAccent, 0.4);\n  //     }\n  //   }\n  // }\n}\n\n@include breakpoint(mobile-large) {\n  .srprs-breadcrumbs {\n    li {\n      font: {\n        size: 13px;\n      }\n      > a,\n      > span:first-child {\n        padding: {\n          top: 5px;\n          right: 5px;\n          bottom: 5px;\n          left: 5px;\n        }\n      }\n      .srprs-icon {\n        width: 16px;\n        transform: translateY(-2px);\n      }\n    }\n  }\n}\n\n@include breakpoint(mobile-landscape) {\n  .srprs-breadcrumbs {\n    + h2.srprs-heading {\n      font-size: 30px;\n    }\n  }\n  .is-done {\n    .srprs-label-box {\n      .srprs-icon {\n        display: inline-block !important;\n      }\n    }\n  }\n\n  .srprs-breadcrumbs {\n    li {\n      font: {\n        size: 15px;\n      }\n      > a,\n      > span:first-child {\n        padding: {\n          top: 5px;\n          right: 5px;\n          bottom: 5px;\n          left: 5px;\n        }\n      }\n      .srprs-icon {\n        width: 20px;\n        transform: translateY(-2px);\n      }\n    }\n  }\n}\n\n@include breakpoint(tablet-portrait) {\n  .srprs-breadcrumbs {\n    z-index: z-index(header);\n    margin: {\n      bottom: 12px;\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n$breakpoints: map-deep-get($srprsreactwebsite-config, 'breakpoints');\n\n@mixin breakpoint($screensize) {\n  @if map-has-key($breakpoints, $screensize) {\n    @media screen and (min-width: map-get($breakpoints, $screensize)) {\n      @content;\n    }\n  } @else {\n    @media screen and (min-width: #{$screensize}) {\n      @content;\n    }\n  }\n}\n\n$height-breakpoints: map-deep-get(\n  $srprsreactwebsite-config,\n  'height-breakpoints'\n);\n\n@mixin height-breakpoint($screensize) {\n  @if map-has-key($height-breakpoints, $screensize) {\n    @media screen and (max-height: map-get($height-breakpoints, $screensize)) {\n      @content;\n    }\n  } @else {\n    @media screen and (max-height: #{$screensize}) {\n      @content;\n    }\n  }\n}\n\n$breakpoint-initial: map-deep-get(\n  $srprsreactwebsite-config,\n  'breakpoints',\n  's'\n);\n@media screen and (max-width: $breakpoint-initial) {\n  body {\n    &:before {\n      content: 'mobile';\n      display: none;\n    }\n  }\n}\n\n@each $breakpoint, $screensize in $breakpoints {\n  @include breakpoint(#{$screensize}) {\n    body {\n      &::before {\n        @if $breakpoint ==\n          l or\n          $breakpoint ==\n          xl or\n          $breakpoint ==\n          xxl or\n          $breakpoint ==\n          xxxl\n        {\n          content: 'desktop';\n        } @else if $breakpoint == m {\n          content: 'tablet';\n        } @else {\n          content: 'mobile';\n        }\n        display: none;\n      }\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n// we should thank http://browserhacks.com/ for this great roundup of dirt\n\n@mixin browserfix($browser) {\n  @if ($browser == 'ie') {\n    // the allmighty IE, 10 and up. 9 and lower requires usage of conditional comments, just stash your code in assets/styles/ie.scss\n    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n      @content;\n    }\n  } @else if ($browser == 'firefox') {\n    // firefox 3 and up\n    @-moz-document url-prefix() {\n      @content;\n    }\n  } @else if ($browser == 'opera') {\n    // opera 9.5 and up\n    _:-o-prefocus,\n    body:last-child .selector {\n      @content;\n    }\n  } @else if ($browser == 'safari') {\n    // all safari\n    .selector:not(*:root) {\n      @content;\n    }\n  } @else if ($browser == 'chrome') {\n    // chrome 28 and up\n    @supports (-webkit-appearance: none) {\n      @content;\n    }\n  }\n}\n\n/*\n\tusage:\n\n\t.element {\n\t\t@include browserfix(ie) {\n\t\t\t&:after {\n\t\t\t\tcontent: \"This is IE only\"\n\t\t\t}\n\t\t}\n\t\t@include browserfix(firefox) {\n\t\t\t&:after {\n\t\t\t\tcontent: \"Only Firefox users will see this\";\n\t\t\t}\n\t\t}\n\t}\n*/\n","@charset \"UTF-8\";\n\n@keyframes buttonDisabled {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0);\n  }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0);\n  }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0);\n  }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
